import { httpRequest } from "../../http";
export class CommandGenerateConversions {
  async run(runId: number): Promise<{ job_id: number }> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/files/${runId}/generate-conversions/`;
    return httpRequest<{ job_id: number }>(url, { method: "POST" });
  }
}
